import { put } from 'redux-saga/effects'
import { verifyUser, getAllUser, getUsersByProviderName } from '../../Services'

export function* verifyUserSaga(action) {
    const payload = action.payload
    try {
        const res = yield  verifyUser(payload)
        yield put({ type: 'REQ_VERIFY_USER_SUCCEEDED', data: res.data })
    }

    catch (e) {
        yield put({ type: 'REQ_VERIFY_USER_FAILED', errData: e})
    }
}

export function* getAllUserSaga(action) {
    const payload = action.payload
    try {
        const res = yield getAllUser(payload)
        yield put({type: 'REQ_GET_ALL_USER_SUCCEEDED', data: res.data})
    } 

    catch (e) {
        yield put({type: 'REQ_GET_ALL_USER_FAILED', errData: e})
    }
}

export function* getUsersByProviderNameSaga(action) {
    const payload = action.payload
    try {
        const res = yield getUsersByProviderName(payload)
        yield put({type: 'REQ_GET_USER_BY_PROVIDER_NAME_SUCCEEDED', data: res.data})
    } 

    catch (e) {
        yield put({type: 'REQ_GET_USER_BY_PROVIDER_NAME_FAILED', errData: e})
    }
}
